<template>
  <v-footer app color="white">
    <v-col class="text-center grey--text" cols="12">
      <strong>{{ name }}</strong> — {{ version }}
    </v-col>
  </v-footer>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: "---",
    },
    version: {
      type: String,
      required: true,
      default: "0.0.0",
    },
  },
};
</script>
